import { Center, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconSearch } from 'ui-icons';

const NoResults = ({ isLoading }: { isLoading?: boolean }) => {
  if (isLoading) return null;
  return (
    <Center>
      <Stack gap="sm" p="md" align="center">
        <ThemeIcon p="md" size={60} radius="100%" bg="gray.1">
          <IconSearch size={24} />
        </ThemeIcon>
        <Text fz="sm" c="gray.6">
          No Results Found
        </Text>
      </Stack>
    </Center>
  );
};

export { NoResults };
